import { IconLink } from '@components/iconLink';
import { useFragment } from 'react-relay';
import { linkListFragment } from './LinkList.relay';
import type { LinkListPropsType } from './types';

const LinkList: React.FC<LinkListPropsType> = (props: LinkListPropsType) => {
  const linkList = useFragment(linkListFragment, props.linkList);

  return (
    <div className="mb-[35px] [&_ul]:list-none [&_li]:flex [&_li]:items-center [&_li]:my-1">
      <h4 className="text-accent uppercase mb-3 text-xs">{linkList.title}</h4>
      <ul>
        {linkList.links.map((link, index) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: static here
          <li key={index}>
            <IconLink iconLink={link} />
          </li>
        ))}
      </ul>
    </div>
  );
};

export { LinkList };
